const buttonFileDownBtn = {
  text: 'Download ZIP Report (max. 10)'
};

export default buttonFileDownBtn;
